// This file configures the initialization of Sentry on the client.
// Next.js automatically loads this file on the client side before React hydration.
// Works with both Turbopack and webpack builds.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://a10225f49f01b1ecf8f233a234d045b7@o4508698181107712.ingest.de.sentry.io/4508840757231696',

  // Only enable Sentry when in production:
  enabled: process.env.NODE_ENV === 'production',

  // Enables sending personally identifiable information (PII) such as user email to Sentry along with events
  sendDefaultPii: true,

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.01,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.01,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 0.01,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})
